// 引入文件
import request from '../utils/request'

// 获取课程列表
export function getCourseList(data) {
    return request({
        url: 'https://api.ihatoo.net/operation/crmProduct/productsByCategoryId',
        method: 'post',
        data
    })
}

// 获取教师列表
export function getTeacherList(data) {
    return request({
        url: 'https://api.ihatoo.net/operation/crmTeacher/list',
        method: 'post',
        data
    })
}

// 获取评论列表
export function getCommentList(data) {
    return request({
        url: 'https://api.ihatoo.net/operation/crmParentalComments/list',
        method: 'post',
        data
    })
}



